import Header from "../../shared/components/layout/Header";
import Wrapper from "../../shared/components/layout/Wrapper";
import Footer from "../../shared/components/layout/Footer";
import SEO from "../../shared/components/layout/SEO";
import NotFoundIcon from "../../assets/images/not-found.png";
import { useLanguage } from "../../context/LanguageProvider";
import PageLayout from "../../shared/components/layout/PageLayout";

const NotFound = () => {
    const { t } = useLanguage();

    return (
        <>
            {/* noIndex keeps this page out of search results (see the SEO update below) */}
            <SEO
                title={t.seo.notFound.title}
                description={t.seo.notFound.description}
                path="/not-found"
                noIndex
            />

            <PageLayout>
                <Wrapper className="flex-1 my-10">
                    <div className="w-1/2 mx-auto">
                        <img
                            src={NotFoundIcon}
                            alt={t.notFound.imageAlt}
                            className="w-3/4 mx-auto"
                        />

                        <p className="text-3xl text-center mt-8">
                            {t.notFound.heading}
                        </p>
                    </div>
                </Wrapper>
            </PageLayout>
        </>
    );
};

export default NotFound;